import { render, staticRenderFns } from "./TagSelectorModal.vue?vue&type=template&id=434bc045&scoped=true&"
import script from "./TagSelectorModal.vue?vue&type=script&lang=js&"
export * from "./TagSelectorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434bc045",
  null
  
)

export default component.exports